import React from 'react';
import styled from '@emotion/styled';
import { withTheme } from '@emotion/react';

import { goFullScreen } from '../util/go_full_screen';

const PromoPage = props => {
  const { Grid, Img } = PromoPage;

  return (
    <Grid>
      <Img src={props.data.image_url} onClick={goFullScreen} />
    </Grid>
  );
};

PromoPage.Grid = styled.div`
  display: grid;

  background-image: url(${props => props.theme.promoPage});

  height: 100%;
  width: 100%;
`;

PromoPage.Img = styled.img`
  position: absolute;

  height: 100%;
  width: 100%;
`;

export default withTheme(PromoPage);
